const TurnsCounts = ({ title, count, color }) => {
    return (
        <div className="d-flex align-items-center justify-content-center flex-column gap-2">

            <div className="position-relative">

                <img src="./calendar_month.png" alt="calender" />

                <span
                    style={{ backgroundColor: color }}
                    className="d-flex align-content-center fs-12 fw-regularer text-white justify-content-center px-1 calendar_count_circle"
                >
                    {count}
                </span>

            </div>

            <p className="m-0 fs-14 color-bootstrap-gray-800 fw-regularer">{title}</p>

        </div>
    )
}

export default TurnsCounts